import {CdkScrollable, ScrollDispatcher} from '@angular/cdk/overlay';
import {Component, HostListener, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {InspectorService} from '@app/inspector/inspector.service';
import {Point, Rect} from '@app/shared/euclid';
import {ManagedComponent} from '@app/shared/managed.component';
import {StateService} from '@app/state/state.service';
import {SelectionService} from '../selection.service';

@Component({
    selector: 'frog-selection',
    templateUrl: './selection.component.html',
    styleUrls: ['./selection.component.scss'],
    standalone: true,
})
export class SelectionComponent extends ManagedComponent implements OnInit {
    public rect: Rect;
    public active: boolean;
    public isMouseDown: boolean;
    private origin: Point;
    private offset: Point;
    private isAvailable: boolean;
    private readonly distanceToActive: number = 10.0;

    constructor(
        private selectionService: SelectionService,
        private stateService: StateService,
        private inspectorService: InspectorService,
        private scrollService: ScrollDispatcher,
        private matDialog: MatDialog,
    ) {
        super();

        this.origin = new Point();
        this.active = false;
        this.rect = new Rect();
        this.offset = new Point(this.inspectorService.isInspecting ? 400 : 0, 0);
    }

    ngOnInit(): void {
        this.offset.y = document.querySelector('.mat-sidenav-content').scrollTop;
        let sub = this.scrollService
            .scrolled(500)
            .subscribe((data: CdkScrollable) => (this.offset.y = data.measureScrollOffset('top')));
        this.subscriptions.push(sub);

        sub = this.stateService.state.subscribe(
            (state) => (this.isAvailable = state.viewingAsset === null),
        );
        this.subscriptions.push(sub);

        sub = this.inspectorService.asset.subscribe((asset) => (this.isAvailable = asset === null));
        this.subscriptions.push(sub);
    }

    @HostListener('window:mouseup')
    up() {
        this.isMouseDown = false;
        this.active = false;
        document.body.classList.remove('noselect');
    }

    @HostListener('window:mousedown', ['$event'])
    down(event: MouseEvent) {
        if (this.matDialog.openDialogs.length > 0 || !this.isAvailable) {
            return;
        }

        if (event.button == 0) {
            event.preventDefault();
            document.body.classList.add('noselect');
            this.isMouseDown = true;
            this.origin.x = event.clientX - this.offset.x;
            this.origin.y = event.clientY + this.offset.y;
            this.rect.zero();
        }
    }

    @HostListener('window:mousemove', ['$event'])
    move(event: MouseEvent) {
        if (this.isMouseDown) {
            event.preventDefault();
            const x: number = event.clientX - this.offset.x - this.origin.x;
            const y: number = event.clientY + this.offset.y - this.origin.y;
            this.rect.width = 0;
            this.rect.height = 0;

            if (x > 0) {
                this.rect.width = x;
                this.rect.x = this.origin.x;
            } else {
                this.rect.width = Math.abs(x);
                this.rect.x = this.origin.x + x;
            }
            if (y > 0) {
                this.rect.height = y;
                this.rect.y = this.origin.y;
            } else {
                this.rect.height = Math.abs(y);
                this.rect.y = this.origin.y + y;
            }

            if (this.active) {
                this.selectionService.setSelectionMask(this.rect);
            } else {
                this.active =
                    this.origin.distance(
                        new Point(event.clientX - this.offset.x, event.clientY + this.offset.y),
                    ) > this.distanceToActive;
            }
        }
    }
}
